// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1HLOK","description":"PatientConsentPreview_description__1KSCH"};